import { useEffect, useState } from "react";

export const STATUS_LABELS = {
  pendiente: "Pendiente",
  en_progreso: "En progreso",
  completado: "Completado",
  escalado: "Escalado",
};

export const PRIORITY_LABELS = {
  alta: "Alta",
  media: "Media",
  baja: "Baja",
};

export const SERVICE_LABELS = {
  correctivo: "Correctivo",
  preventivo: "Preventivo",
};

export const MODALITY_LABELS = {
  presencial: "Presencial",
  remoto: "Remoto",
};

const STATUS_STYLES = {
  pendiente: "bg-yellow-50 text-yellow-700 border-yellow-200",
  en_progreso: "bg-blue-50 text-blue-700 border-blue-200",
  completado: "bg-green-50 text-green-700 border-green-200",
  escalado: "bg-red-50 text-red-700 border-red-200",
};

const PRIORITY_STYLES = {
  alta: "bg-red-50 text-red-700 border-red-200",
  media: "bg-blue-50 text-blue-700 border-blue-200",
  baja: "bg-slate-50 text-slate-600 border-slate-200",
};

export function StatusBadge({ status, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status] || STATUS_STYLES.pendiente}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function PriorityBadge({ priority, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${PRIORITY_STYLES[priority] || PRIORITY_STYLES.media}`}
    >
      {PRIORITY_LABELS[priority] || priority}
    </span>
  );
}

export function ElapsedTime({ since, high, testId }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(interval);
  }, []);
  const diff = Date.now() - new Date(since).getTime();
  const mins = Math.max(0, Math.floor(diff / 60000));
  const days = Math.floor(mins / 1440);
  const hours = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  const label = days > 0 ? `${days}d ${hours}h` : hours > 0 ? `${hours}h ${m}m` : `${m}m`;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-mono text-xs font-medium ${
        high
          ? "animate-pulse-soft bg-red-50 text-red-700 border border-red-200"
          : "bg-slate-100 text-slate-600 border border-slate-200"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${high ? "bg-red-500" : "bg-blue-500"}`} />
      {label}
    </span>
  );
}
